export const GET_ALL_SUBSCRIPTIONS = `
  query {
    allSuscription {
      id
      name
      codeSubcription
    }
  }
`;

export const GET_ALL_SUBSCRIPTIONS_ALL = `
  query {
    allSubcriptionAll {
      id
      name
      codeSubcription
    }
  }
`;

export const VALIDATION_SUBCRIPTION_TECHNICIAN= `
 mutation($requestSubcription: JSON) { 
    validationSubscription(requestSubcription: $requestSubcription) { 
      message 
      result       
    } 
  }
`;

export const GET_RECORD_TECHNICIAN = `
  query getRecordSubcriptionTechnician($id_technician: String) {
      getRecordSubcriptionTechnician(id_technician: $id_technician) {
          message
          suscriptionTech {
              id_subcription
              name_subcription
              description_subcription
              price_subcription
              startSubcription
              endSubcription
              statusSubcription
          }
      }
  }
`;

export const GET_ALL_SUBCRIPTION_PLAIN = `
  query {
      allSubcriptionPlain {
          id
          name
          description
          codeSubcription
          durationDescription
          duration
          price
          createDate
          status
      }
  }
`;

export const DETAILS_SUBCRIPTION_TECH = `
  query getLstTechnicianSuscrip($suscriptionId: String!) {
      getLstTechnicianSuscrip(suscriptionId: $suscriptionId) {
          message
          count
          name_sub
          content {
              full_name
              startdate
              enddate
              phone
              avg
              status
          }
      }
  }
`;
